import React, { FC } from "react";
import styles from "./Navbar.module.css";
import DesktopNavbar from "./DesktopNavbar/DesktopNavbar";
import MobileNavbar from "./MobileNavbar/MobileNavbar";

interface NavbarProps {}

const Navbar: FC<NavbarProps> = () => (
  <div className={styles.Navbar} data-testid="Navbar">
    <div className={styles.Desktop}>
      <DesktopNavbar />
    </div>
    <div className={styles.Mobile}>
      <MobileNavbar />
    </div>
  </div>
);

export default Navbar;
